export default [
    {
        lat: 49.84,
        lng: 10.42,
    },
    {
        lat: 49.885,
        lng: 10.435,
    },
    {
        lat: 49.9,
        lng: 10.455,
    },
    {
        lat: 49.9,
        lng: 10.57,
    },
    {
        lat: 49.89,
        lng: 10.585,
    },
    {
        lat: 49.895,
        lng: 10.59,
    },
    {
        lat: 49.89,
        lng: 10.625,
    },
    {
        lat: 49.91,
        lng: 10.65,
    },
    {
        lat: 49.91,
        lng: 10.67,
    },
    {
        lat: 49.925,
        lng: 10.675,
    },
    {
        lat: 49.945,
        lng: 10.705,
    },
    {
        lat: 49.97,
        lng: 10.705,
    },
    {
        lat: 49.98,
        lng: 10.725,
    },
    {
        lat: 50,
        lng: 10.72,
    },
    {
        lat: 50.01,
        lng: 10.73,
    },
    {
        lat: 50.03,
        lng: 10.73,
    },
    {
        lat: 50.04,
        lng: 10.75,
    },
    {
        lat: 50.065,
        lng: 10.77,
    },
    {
        lat: 50.06,
        lng: 10.815,
    },
    {
        lat: 50.065,
        lng: 10.81,
    },
    {
        lat: 50.085,
        lng: 10.82,
    },
    {
        lat: 50.095,
        lng: 10.835,
    },
    {
        lat: 50.125,
        lng: 10.84,
    },
    {
        lat: 50.12,
        lng: 10.785,
    },
    {
        lat: 50.135,
        lng: 10.76,
    },
    {
        lat: 50.185,
        lng: 10.76,
    },
    {
        lat: 50.21,
        lng: 10.735,
    },
    {
        lat: 50.21,
        lng: 10.72,
    },
    {
        lat: 50.225,
        lng: 10.705,
    },
    {
        lat: 50.25,
        lng: 10.705,
    },
    {
        lat: 50.27,
        lng: 10.72,
    },
    {
        lat: 50.27,
        lng: 10.75,
    },
    {
        lat: 50.26,
        lng: 10.76,
    },
    {
        lat: 50.27,
        lng: 10.785,
    },
    {
        lat: 50.275,
        lng: 10.76,
    },
    {
        lat: 50.295,
        lng: 10.74,
    },
    {
        lat: 50.305,
        lng: 10.7,
    },
    {
        lat: 50.355,
        lng: 10.69,
    },
    {
        lat: 50.385,
        lng: 10.71,
    },
    {
        lat: 50.38,
        lng: 10.745,
    },
    {
        lat: 50.39,
        lng: 10.765,
    },
    {
        lat: 50.405,
        lng: 10.775,
    },
    {
        lat: 50.4,
        lng: 10.8,
    },
    {
        lat: 50.415,
        lng: 10.83,
    },
    {
        lat: 50.415,
        lng: 10.89,
    },
    {
        lat: 50.405,
        lng: 10.9,
    },
    {
        lat: 50.415,
        lng: 10.935,
    },
    {
        lat: 50.395,
        lng: 10.975,
    },
    {
        lat: 50.38,
        lng: 10.98,
    },
    {
        lat: 50.385,
        lng: 11.02,
    },
    {
        lat: 50.38,
        lng: 11.045,
    },
    {
        lat: 50.37,
        lng: 11.05,
    },
    {
        lat: 50.37,
        lng: 11.065,
    },
    {
        lat: 50.385,
        lng: 11.08,
    },
    {
        lat: 50.39,
        lng: 11.105,
    },
    {
        lat: 50.375,
        lng: 11.145,
    },
    {
        lat: 50.345,
        lng: 11.175,
    },
    {
        lat: 50.32,
        lng: 11.18,
    },
    {
        lat: 50.305,
        lng: 11.17,
    },
    {
        lat: 50.31,
        lng: 11.21,
    },
    {
        lat: 50.3,
        lng: 11.23,
    },
    {
        lat: 50.315,
        lng: 11.24,
    },
    {
        lat: 50.315,
        lng: 11.235,
    },
    {
        lat: 50.345,
        lng: 11.245,
    },
    {
        lat: 50.355,
        lng: 11.24,
    },
    {
        lat: 50.37,
        lng: 11.255,
    },
    {
        lat: 50.39,
        lng: 11.24,
    },
    {
        lat: 50.43,
        lng: 11.245,
    },
    {
        lat: 50.43,
        lng: 11.235,
    },
    {
        lat: 50.445,
        lng: 11.225,
    },
    {
        lat: 50.49,
        lng: 11.23,
    },
    {
        lat: 50.5,
        lng: 11.24,
    },
    {
        lat: 50.505,
        lng: 11.295,
    },
    {
        lat: 50.53,
        lng: 11.315,
    },
    {
        lat: 50.545,
        lng: 11.37,
    },
    {
        lat: 50.535,
        lng: 11.435,
    },
    {
        lat: 50.51,
        lng: 11.46,
    },
    {
        lat: 50.48,
        lng: 11.455,
    },
    {
        lat: 50.475,
        lng: 11.44,
    },
    {
        lat: 50.46,
        lng: 11.445,
    },
    {
        lat: 50.45,
        lng: 11.455,
    },
    {
        lat: 50.45,
        lng: 11.495,
    },
    {
        lat: 50.425,
        lng: 11.505,
    },
    {
        lat: 50.415,
        lng: 11.515,
    },
    {
        lat: 50.415,
        lng: 11.53,
    },
    {
        lat: 50.4,
        lng: 11.535,
    },
    {
        lat: 50.42,
        lng: 11.565,
    },
    {
        lat: 50.425,
        lng: 11.59,
    },
    {
        lat: 50.41,
        lng: 11.62,
    },
    {
        lat: 50.41,
        lng: 11.65,
    },
    {
        lat: 50.415,
        lng: 11.69,
    },
    {
        lat: 50.425,
        lng: 11.705,
    },
    {
        lat: 50.42,
        lng: 11.725,
    },
    {
        lat: 50.435,
        lng: 11.745,
    },
    {
        lat: 50.44,
        lng: 11.8,
    },
    {
        lat: 50.425,
        lng: 11.815,
    },
    {
        lat: 50.42,
        lng: 11.855,
    },
    {
        lat: 50.435,
        lng: 11.875,
    },
    {
        lat: 50.445,
        lng: 11.94,
    },
    {
        lat: 50.41,
        lng: 11.98,
    },
    {
        lat: 50.405,
        lng: 12,
    },
    {
        lat: 50.37,
        lng: 12.005,
    },
    {
        lat: 50.36,
        lng: 12.04,
    },
    {
        lat: 50.35,
        lng: 12.05,
    },
    {
        lat: 50.355,
        lng: 12.09,
    },
    {
        lat: 50.345,
        lng: 12.11,
    },
    {
        lat: 50.335,
        lng: 12.11,
    },
    {
        lat: 50.32,
        lng: 12.145,
    },
    {
        lat: 50.3,
        lng: 12.145,
    },
    {
        lat: 50.285,
        lng: 12.16,
    },
    {
        lat: 50.255,
        lng: 12.15,
    },
    {
        lat: 50.255,
        lng: 12.16,
    },
    {
        lat: 50.22,
        lng: 12.195,
    },
    {
        lat: 50.22,
        lng: 12.205,
    },
    {
        lat: 50.175,
        lng: 12.235,
    },
    {
        lat: 50.16,
        lng: 12.235,
    },
    {
        lat: 50.13,
        lng: 12.215,
    },
    {
        lat: 50.115,
        lng: 12.24,
    },
    {
        lat: 50.12,
        lng: 12.245,
    },
    {
        lat: 50.115,
        lng: 12.26,
    },
    {
        lat: 50.095,
        lng: 12.275,
    },
    {
        lat: 50.085,
        lng: 12.295,
    },
    {
        lat: 50.07,
        lng: 12.295,
    },
    {
        lat: 50.055,
        lng: 12.28,
    },
    {
        lat: 50.035,
        lng: 12.275,
    },
    {
        lat: 50.015,
        lng: 12.25,
    },
    {
        lat: 50.015,
        lng: 12.22,
    },
    {
        lat: 49.995,
        lng: 12.22,
    },
    {
        lat: 49.98,
        lng: 12.21,
    },
    {
        lat: 49.98,
        lng: 12.175,
    },
    {
        lat: 49.965,
        lng: 12.15,
    },
    {
        lat: 49.97,
        lng: 12.13,
    },
    {
        lat: 49.955,
        lng: 12.11,
    },
    {
        lat: 49.955,
        lng: 12.09,
    },
    {
        lat: 49.965,
        lng: 12.075,
    },
    {
        lat: 49.96,
        lng: 12.06,
    },
    {
        lat: 49.965,
        lng: 12.015,
    },
    {
        lat: 49.94,
        lng: 11.85,
    },
    {
        lat: 49.91,
        lng: 11.86,
    },
    {
        lat: 49.9,
        lng: 11.875,
    },
    {
        lat: 49.875,
        lng: 11.87,
    },
    {
        lat: 49.865,
        lng: 11.88,
    },
    {
        lat: 49.84,
        lng: 11.88,
    },
    {
        lat: 49.83,
        lng: 11.87,
    },
    {
        lat: 49.83,
        lng: 11.845,
    },
    {
        lat: 49.82,
        lng: 11.83,
    },
    {
        lat: 49.825,
        lng: 11.81,
    },
    {
        lat: 49.815,
        lng: 11.795,
    },
    {
        lat: 49.82,
        lng: 11.75,
    },
    {
        lat: 49.8,
        lng: 11.735,
    },
    {
        lat: 49.8,
        lng: 11.72,
    },
    {
        lat: 49.78,
        lng: 11.7,
    },
    {
        lat: 49.785,
        lng: 11.695,
    },
    {
        lat: 49.78,
        lng: 11.65,
    },
    {
        lat: 49.755,
        lng: 11.655,
    },
    {
        lat: 49.74,
        lng: 11.635,
    },
    {
        lat: 49.74,
        lng: 11.62,
    },
    {
        lat: 49.71,
        lng: 11.6,
    },
    {
        lat: 49.705,
        lng: 11.58,
    },
    {
        lat: 49.655,
        lng: 11.585,
    },
    {
        lat: 49.625,
        lng: 11.57,
    },
    {
        lat: 49.62,
        lng: 11.54,
    },
    {
        lat: 49.63,
        lng: 11.515,
    },
    {
        lat: 49.62,
        lng: 11.475,
    },
    {
        lat: 49.61,
        lng: 11.47,
    },
    {
        lat: 49.605,
        lng: 11.445,
    },
    {
        lat: 49.595,
        lng: 11.44,
    },
    {
        lat: 49.605,
        lng: 11.39,
    },
    {
        lat: 49.645,
        lng: 11.36,
    },
    {
        lat: 49.62,
        lng: 11.345,
    },
    {
        lat: 49.61,
        lng: 11.315,
    },
    {
        lat: 49.585,
        lng: 11.295,
    },
    {
        lat: 49.585,
        lng: 11.27,
    },
    {
        lat: 49.575,
        lng: 11.26,
    },
    {
        lat: 49.58,
        lng: 11.22,
    },
    {
        lat: 49.565,
        lng: 11.18,
    },
    {
        lat: 49.57,
        lng: 11.095,
    },
    {
        lat: 49.61,
        lng: 11.055,
    },
    {
        lat: 49.61,
        lng: 11.015,
    },
    {
        lat: 49.63,
        lng: 11,
    },
    {
        lat: 49.655,
        lng: 11.01,
    },
    {
        lat: 49.66,
        lng: 10.965,
    },
    {
        lat: 49.675,
        lng: 10.955,
    },
    {
        lat: 49.69,
        lng: 10.91,
    },
    {
        lat: 49.705,
        lng: 10.9,
    },
    {
        lat: 49.72,
        lng: 10.905,
    },
    {
        lat: 49.72,
        lng: 10.865,
    },
    {
        lat: 49.735,
        lng: 10.855,
    },
    {
        lat: 49.735,
        lng: 10.845,
    },
    {
        lat: 49.72,
        lng: 10.83,
    },
    {
        lat: 49.72,
        lng: 10.79,
    },
    {
        lat: 49.745,
        lng: 10.775,
    },
    {
        lat: 49.76,
        lng: 10.725,
    },
    {
        lat: 49.745,
        lng: 10.73,
    },
    {
        lat: 49.715,
        lng: 10.715,
    },
    {
        lat: 49.71,
        lng: 10.685,
    },
    {
        lat: 49.7,
        lng: 10.675,
    },
    {
        lat: 49.7,
        lng: 10.65,
    },
    {
        lat: 49.72,
        lng: 10.63,
    },
    {
        lat: 49.72,
        lng: 10.6,
    },
    {
        lat: 49.735,
        lng: 10.545,
    },
    {
        lat: 49.775,
        lng: 10.51,
    },
    {
        lat: 49.765,
        lng: 10.495,
    },
    {
        lat: 49.77,
        lng: 10.455,
    },
    {
        lat: 49.84,
        lng: 10.42,
    },
];
